<template>
  <div>
    <dashboard-page-title  :showAddBtn="false" :showFilter="false" :showSearch="false" :showExportation="false">العيادات</dashboard-page-title>
    <main-table :fields="fields" list_url="admin/clinics"  :baseURL="VUE_APP_VETE_LINK" :additional-url="`&status=accepted`" :reloadData="reloadData"></main-table>

    <b-modal id="suspendedModal" size="lg" title="سبب ايقاف العيادة" style="direction: rtl" centered hide-footer hide-header-close @hidden="resetForm">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <b-row class="d-flex flex-wrap">
          <b-col>
            <textarea-form placeholder="السبب" v-model="reason" label="سبب مختصر" name="reason" validate="required"></textarea-form>
          </b-col>
        </b-row>
      </form>
    </ValidationObserver>

      <div class="d-flex justify-content-center mt-2">
        <b-button v-if='saveButton' class="btn btn-primary float-right" variant="primary" disabled>
          <spinner-loading text = 'Loading' />
        </b-button>
        <b-button variant="primary" v-else class="w-50" @click="handleSuspendHospital">Save</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { VUE_APP_VETE_LINK } from '@/config/constant'
import api from '../../services/index'
export default {
  components: {},
  mounted () {
    core.index()
  },
  data () {
    return {
      VUE_APP_VETE_LINK,
      reloadData: true,
      saveButton: false,
      suspendedId: '',
      reason: '',
      fields: [
        { label: 'Id', key: 'id', class: 'text-right', sortable: true },
        { label: 'شعار العيادة', key: 'logo', class: 'text-right', type: 'image' },
        { label: 'اسم العيادة', key: 'clinic_name', class: 'text-right' },
        { label: 'عدد الأطباء', key: 'doctors_num', class: 'text-right' },
        { label: 'عدد الحجوزات', key: 'reservations_num', class: 'text-right' },
        { label: 'الحالة', key: 'status', class: 'text-right', type: 'status' },
        { label: 'تاريخ الإنشاء', key: 'created_at', class: 'text-right' },
        { label: 'نسبة العمولة', key: 'fees', class: 'text-right' },
        {
          label: 'التحكم',
          key: 'actions',
          class: 'text-right',
          type: 'actions',
          actions: [
            {
              text: 'view clinic',
              icon: 'ri-eye-fill',
              color: 'primary',
              ifNavigate: true,
              routePath: 'show-hospital/:id'
            },
            {
              text: 'edit clinic',
              icon: 'ri-ball-pen-fill',
              color: 'info',
              ifNavigate: true,
              routePath: 'edit-hospital/:id'
            },
            {
              text: 'suspend clinic',
              icon: 'ri-delete-bin-line',
              color: 'danger',
              actionParams: ['id'],
              actionName: 'showSuspensedModal'
            }
          ]
        }
      ]
    }
  },
  methods: {
    addMerchant () {
      console.log('hello')
    },
    resetForm () {
      this.reason = '' // Reset the reason when modal is hidden
    },
    showSuspensedModal (data) {
      this.suspendedId = data.id
      this.$bvModal.show('suspendedModal')
    },
    handleSuspendHospital () {
      this.saveButton = true
      api.statusClinic(this.suspendedId, 'suspended', { mail_body: this.reason }).then(res => {
        core.showSnackbar('success', 'تم  ايقاف العيادة بنجاح')
        this.saveButton = false
        this.$bvModal.hide('suspendedModal')
        this.reloadData = true
      })
      this.reloadData = false
    }
  },
  created () {
    this.$root.$on('showSuspensedModal', this.showSuspensedModal)
  }
}
</script>
